import {
    type CustomItemFormStructure,
    FlexyForm,
    type FlexyInputFormStructure,
    type FormStructure,
    type FormObject,
} from '@europrocurement/flexy-form';
import { Box, Button } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { dateToISOYmd } from '@europrocurement/l2d-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-duotone-svg-icons';
import { type DashboardFiltersType } from '../../containers/FormalistDashboard/FormalistDashboard';

type FiltersDashboarProps = {
    setFilters: React.Dispatch<React.SetStateAction<DashboardFiltersType>>;
    isSubmitting: boolean;
    initialStartDate: string;
};
const FiltersDashboard: React.FunctionComponent<FiltersDashboarProps> = function ({
    setFilters,
    isSubmitting,
    initialStartDate,
}) {
    // Form
    const formContext = useForm<FormObject>({
        mode: 'onTouched',
        defaultValues: {
            startedAt: new Date(initialStartDate),
        },
    });

    const handleFilterSubmit = () => {
        if (isSubmitting) {
            return;
        }
        const { startedAt, endedAt } = formContext.getValues();
        setFilters({
            startedAt: startedAt ? dateToISOYmd(startedAt as Date) : initialStartDate,
            endedAt: endedAt ? dateToISOYmd(endedAt as Date) : undefined,
        });
    };

    const formStructure: FormStructure[] = [
        {
            type: 'date',
            name: 'startedAt',
            rules: { required: 'Ce champ est requis' },
            xs: 4,
            lg: 2.8,
            size: 'small',
        } as FlexyInputFormStructure,
        {
            type: 'date',
            name: 'endedAt',
            xs: 4,
            lg: 2.8,
            size: 'small',
        } as FlexyInputFormStructure,
        {
            type: 'customItem',
            name: 'submitButton',
            xs: 2,
            lg: 1,
            size: 'small',
            renderField: () => (
                <Button
                    variant="contained"
                    type="button"
                    onClick={handleFilterSubmit}
                    sx={{
                        padding: '12px 12px',
                        fontSize: '16px',
                        transition: 'all ease-in-out 300ms',
                    }}
                >
                    <FontAwesomeIcon icon={faFilter} />
                </Button>
            ),
        } as CustomItemFormStructure,
    ];

    const formProps = {
        formContext,
        formObject: {},
        onSubmit: () => {},
        gridProps: {
            sx: { paddingX: '8px', gap: '8px', alignItems: 'end', justifyContent: 'flex-end' },
        },
        submitButton: {
            label: '',
            displayed: false,
        },
        isSubmitting,
    };

    return (
        <Box
            onClick={(e) => {
                // Prevent accordion toggle expand on filters click
                e.stopPropagation();
            }}
        >
            <FlexyForm
                formStructure={formStructure}
                {...formProps}
            />
        </Box>
    );
};

export default FiltersDashboard;
